import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: false,
  error: null,
  errorStatus: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.errorStatus = null;
    },
    setUserLoading: (state) => {
      state.loading = true;
      state.error = null;
      state.errorStatus = null;
    },
    setUserError: (state, action) => {
      state.loading = false;
      if (typeof action.payload === "string") {
        state.error = action.payload;
        state.errorStatus = null;
      } else {
        state.error = action.payload?.message || "Something went wrong";
        state.errorStatus = action.payload?.status ?? null;
      }
    },
    clearUser: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.errorStatus = null;
    },
  },
});

export const { setUser, setUserLoading, setUserError, clearUser } =
  userSlice.actions;

export default userSlice.reducer;
